<template>
    <iframe src="https://metabase.carnegosystems.net/public/question/1543b265-8ac3-4b87-ae2a-aac0e064fab6" frameborder="0" width="1200"    height="800" allowtransparency></iframe>
</template>

<script lang="ts">

import { Component, Ref, Vue } from 'vue-property-decorator';

@Component({
    components: {
    },
})
export default class DataQuality extends Vue {

    public async mounted() {
        const self = this;
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>